export const ReactErrorType = "ReactError";
export const NotFoundErrorType = "NotFoundError";
export const UnauthorizedErrorType = "UnauthorizedError";
export const StreamPermissionErrorType = "StreamPermissionError";
export const createReactError = (error, info) => ({
  error,
  info,
  type: ReactErrorType
});
export const createNotFoundError = (error) => ({
  error,
  type: NotFoundErrorType
});
export const createUnauthorizedError = (error) => ({
  error,
  type: UnauthorizedErrorType
});
export const createStreamPermissionError = (error) => ({
  error,
  type: StreamPermissionErrorType
});
export const createFromFetchError = (error) => {
  var _a, _b;
  switch (error.status) {
    case 403:
      return ((_b = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.body) == null ? void 0 : _b.type) === "MissingStreamPermission" ? createStreamPermissionError(error) : createUnauthorizedError(error);
    case 404:
      return createNotFoundError(error);
    default:
      throw Error(
        `Provided FetchError is not a valid ReportedError because status code ${error.status} is not supported`
      );
  }
};
